/** @format */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const PreRacePage = lazyWithRetry(() => import("@/pages/PreRace/PreRace"));

const preRaceSearchSchema = z.object({
  tab: z
    .enum([
      "driver-overview",
      "race-schedule",
      "track-performance",
      "track-type-performance",
      "race-profile",
      "race-simulation",
      "standings",
      "standings-charts",
      "crew-list",
      "probabilities",
    ])
    .optional(),
});

export const Route = createFileRoute("/race/$raceId/pre-race")({
  validateSearch: preRaceSearchSchema,

  component: () => (
    <Suspense fallback={<PageLoader />}>
      <PreRacePage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
